import { CustomSize } from "@/src/context/product/current-product-context"
import { AnswerFromCustomer } from "./wizard"
import ItemInfos from "@/src/interfaces/catalog/item-infos"
import { CurrentHalfSelectedComplements } from "@/src/components/product/products/size-product/config-product-by-size/config-product-by-size"
import "@/src/extensions/number"
import { useMerchant } from '@/src/context/merchant/merchant-context'

export interface PriceParamsProps {
    currentAnswer: AnswerFromCustomer[]
    currentPrice?: number
    currentProduct?: ItemInfos.DetailedResponse
    sizeProduct?: Partial<CustomSize>
}

export const useCalculationProduct = () => {
    const { merchantDetailed } = useMerchant()

    const getPrice = (props: PriceParamsProps) => {
        const complementList = props.currentAnswer
            .filter((e) => e.type === "complement")
            .flatMap((c) => c.itemOptionsGroup) ?? []

        const priceComplementsSelecteds = complementList
            .reduce((total, option) => total += calculateOptionsGroup(option), 0)

        const productsList = props.currentAnswer.filter((e) => e.type === "product")
        const priceProductsSelecteds = productsList
            .map((e) => e.itemOptionsGroup)
            .flat()
            .reduce((total, option) => total += calculateOptionsGroup(option), 0)

        let currentPrice = props.currentPrice ?? 0

        if ((props.currentProduct?.salePrice ?? 0) <= 0)
            currentPrice = 0

        if (props?.sizeProduct)
            currentPrice = getSizePrice(props.sizeProduct, props.currentAnswer)
        else if (props.currentProduct?.salePrice)
            currentPrice = props.currentProduct.salePrice

        const totalPrice = currentPrice + priceComplementsSelecteds + priceProductsSelecteds

        return totalPrice
    }

    const getSizePrice = (
        sizeProduct: Partial<CustomSize>,
        answers?: AnswerFromCustomer[],
        halfFlavors?: CustomSize[],
        complementsByHalf?: CurrentHalfSelectedComplements[]
    ): number => {
        // Calcular o preço com base no tamanho do produto
        let productPrice = 0
        const chargeForTheHighestAmount = merchantDetailed?.model?.paymentConfiguration.chargeForTheHighestAmount ?? false

        // Calcular o preço baseado em meio a meio
        let percentFlavors = 1.00
        if (halfFlavors && halfFlavors.length > 1) {
            percentFlavors = (1.00 / halfFlavors.length).roundAwayFromZero(4)
            const maxSalePrice = Math.max(...halfFlavors.map((current) => current.salePrice || 0))
            const totalSalePrice = halfFlavors.reduce((prev, current) => {
                const item = ((current.salePrice * percentFlavors) || 0)
                if (current.promoId && current.promoPriceType)
                    return prev + item.priceRoundAwayFromZero()
                else
                    return prev + item.discountRoundAwayFromZero()
            }, 0)

            productPrice = chargeForTheHighestAmount
                ? maxSalePrice.priceRoundAwayFromZero()
                : totalSalePrice.priceRoundAwayFromZero()

            // Adicionar o preço dos complementos meio a meio
            if (halfFlavors && (complementsByHalf && complementsByHalf.length > 0)) {
                const complementsPrice = complementsByHalf.reduce((prev, curr) => {
                    return prev + curr.sizeComplements
                        .reduce(
                            (sum, item) => {
                                return sum + ((item.salePrice * percentFlavors).priceRoundAwayFromZero() || 0)
                            }, 0)
                }, 0)

                productPrice += complementsPrice
            }
        } else if (sizeProduct.salePrice) {
            //sabor único
            productPrice = sizeProduct.salePrice
        }

        let answersPrice = 0

        if (answers) {
            answersPrice = answers.reduce((total, item) => {
                const groupPrice = item.itemOptionsGroup?.reduce(
                    (total, option) => {
                        if (item.type === "complement") {
                            return total += calculateOptionsGroup(option)
                        }
                        else {
                            return total += ((option.promoPrice ?? option.price ?? 0) * option.quantity).priceRoundAwayFromZero()
                        }
                    },
                    0
                ) ?? 0

                return total + groupPrice + (item.price ?? 0)
            }, 0)
        }

        return productPrice + answersPrice
    }

    const calculateOptionsGroup = (option: ItemInfos.ItemOption): number => {
        let subTotal = 0

        if (option?.promoPrice === 0)
            subTotal = 0
        else if (option?.promoPrice > 0)
            subTotal = option?.promoPrice * (option?.quantity ?? 1)
        else
            subTotal = (option?.itemChild?.salePrice ?? 0) * (option.quantity ?? 1)

        return subTotal.priceRoundAwayFromZero()
    }

    return { getPrice, getSizePrice }
}